import ChargeCenter from '@/app/routes/ChargeCenter';
import { chargeCenterRoute } from '@/modules/charge-center/route';
import { createRoute } from '@tanstack/react-router';

// ! Reminder that this doesn't work as expected, must be redone afterwards
export const mapRoute = createRoute({
  getParentRoute: () => chargeCenterRoute,
  path: 'map',
  component: () => {
    return <ChargeCenter initialTab={1} />;
  },
});
